import { render, staticRenderFns } from "./SelectLeadModal.vue?vue&type=template&id=36c5522e&scoped=true&"
import script from "./SelectLeadModal.vue?vue&type=script&lang=js&"
export * from "./SelectLeadModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectLeadModal.vue?vue&type=style&index=0&id=36c5522e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5522e",
  null
  
)

export default component.exports